//============================
//# enum from backend "PartnerPayDateTypes" class
//============================

export default interface PayDayType {
    id: number;
    name: string;
}

export const PayDayTypeDefaultProps: PayDayType = {
    id: 1,
    name: "-"
}